import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";

export default function InvestorStubPage({ section, accent = "sage", icon: Icon }) {
  const { t } = useTranslation();
  const bg = {
    sage: "bg-sageMint/40",
    lavender: "bg-lavenderFog/50",
    sky: "bg-skyMist/50",
    butter: "bg-butterCream/50",
  }[accent] || "bg-sageMint/40";

  return (
    <div className="max-w-3xl mx-auto" data-testid={`inv-portal-stub-${section}`}>
      <motion.header initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4, ease: "easeOut" }}>
        <p className="wit-eyebrow text-raspberry mb-2">{t(`invPortal.stub.${section}.eyebrow`)}</p>
        <h1 className="font-serif text-3xl sm:text-4xl text-cocoa leading-[1.05]">{t(`invPortal.stub.${section}.title`)}</h1>
      </motion.header>

      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: "easeOut", delay: 0.12 }}
        className={`mt-7 rounded-[2rem] border border-sandBeige ${bg} p-8 sm:p-10`}
      >
        {Icon && (
          <div className="w-14 h-14 rounded-2xl bg-white border border-sandBeige flex items-center justify-center text-raspberry">
            <Icon size={22} />
          </div>
        )}
        <p className="font-serif text-2xl text-cocoa mt-5">{t(`invPortal.stub.${section}.headline`)}</p>
        <p className="text-warmGrey leading-relaxed mt-3 max-w-2xl">{t(`invPortal.stub.${section}.body`)}</p>
        <p className="text-xs uppercase tracking-wide text-warmGrey mt-5">{t(`invPortal.stub.${section}.timing`)}</p>
      </motion.div>
    </div>
  );
}
